import React, {FC, Fragment, useEffect, useState} from 'react'
import Link from 'next/link'
import {domainUrl} from '../../../../../helper'
import cls from "./customSearch.module.scss"
import Image from "next/image";
import {IProduct, TranslationsType} from "../../../../../types/homePageTypes";
import {ICurrencies} from "../../MainLayout";

interface IProps {
    products: Array<IProduct>;
    selectedRate: ICurrencies;
    dbName: string;
    translationsData: TranslationsType;
    close: () => void
}

const CustomSuggestions: FC<IProps> = (
    {
        products,
        selectedRate,
        dbName,
        translationsData,
        close
    }
) => {

    const ListJsx = ({ product }: { product: IProduct }) => {
        const positionSymbolHandle = () => {
            const finalPrice = product.flats[0]?.special_price ?? product.flats[0]?.price
            if (selectedRate?.code === "AMD") {
                return finalPrice + " " + selectedRate?.symbol
            }
            return selectedRate?.symbol + " " + finalPrice
        }
        return (
            <Link
                className={cls["suggestions__item-name"]}
                href={`/${product.flats[0].url_key}`}
                key={product.id}
            >
                <li className={cls.suggestions__item} onClick={() => close()}>
                    <div className={`${cls["suggestions__item-image"]} ${cls["product-image"]}`}>
                        <div className={`${cls["search-product-image__body-fms"]}`}>
                            <Link href={`/${product.flats[0].url_key}`}>
                                <a>
                                    <Image
                                        src={domainUrl(`${dbName}${product?.images[0]}`)}
                                        alt={product?.flats[0]?.name}
                                        width={50}
                                        height={50}
                                        priority
                                    />
                                </a>
                            </Link>
                        </div>
                    </div>
                    <div className={cls["suggestions__item-info"]}>
                        <a> {product?.flats[0]?.name}</a>
                        {!product?.notProduct && (
                            <div className={cls["suggestions__item-meta"]}>
                                {`SKU: ${product?.sku}`}
                            </div>
                        )}
                    </div>
                    {!product?.notProduct && (
                        <div className={cls["suggestions__item-price"]}>
                            {positionSymbolHandle()}
                        </div>
                    )}
                </li>
            </Link>
        )
    }
    const ProductsExist = () => {
        if (!products.length) {
            return (
                <div className={cls.search__fm_dr_Message}>
                    {translationsData?.NoMatchingItems}
                </div>
            )
        }

        return <Fragment>
            {products.map((product: IProduct) => <ListJsx product={product} key={product.id}/>)}
        </Fragment>
    }
    return (
        <div className={`${cls.suggestions} ${cls[`suggestions--location--header`]} ${cls.search__suggestions}`}>
            <ul className={cls["suggestions__list"]}><ProductsExist /></ul>
        </div>
    )
};

export default CustomSuggestions
